import { render, staticRenderFns } from "./swipt.vue?vue&type=template&id=0d094eb0&scoped=true&"
import script from "./swipt.vue?vue&type=script&lang=js&"
export * from "./swipt.vue?vue&type=script&lang=js&"
import style0 from "./swipt.vue?vue&type=style&index=0&id=0d094eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d094eb0",
  null
  
)

export default component.exports